import * as zod from 'zod';

export default zod.object({
  latestSaveFilepath: zod.string().nullable(),
  captureTimestamp: zod.string().nullable(),
});
